import React, { useContext, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { OrderContext } from "../../store/OrderContext";
import { useReactToPrint } from "react-to-print";
import OrderedProductsTable from "./OrderedProductsTable";
import OrderPlacedMessage from "./OrderPlacedMessage";
import FloatingMenu from "../../components/menu/FloatingMenu";

const BusinessOrderDetailsPage = () => {
  const { orders } = useContext(OrderContext);
  const printableRef = useRef<HTMLDivElement>(null);
  const [searchParams] = useSearchParams();
  const { orderId } = useParams<{ orderId: string }>();
  const isNew = searchParams.get("new") === "true";
  const activeOrder = orders.find((order) => {
    return order.id === orderId;
  });

  const handlePrint = useReactToPrint({
    contentRef: printableRef,
    documentTitle: "Order Details",
  });
  return (
    <div className="page-container">
      <h1>Order Details</h1>
      <div className="btn-aligned-right-box">
        <button className="btn btn-aligned-right" onClick={handlePrint}>
          <span>🖨️</span> Print Or Save
        </button>
      </div>
      <div className="page-content">
        {isNew && activeOrder && (
          <OrderPlacedMessage order={activeOrder} printableRef={printableRef} />
        )}
        <h3 className="business-order-details-h3">Order Details</h3>
        <div className="print" ref={printableRef}>
          <OrderedProductsTable order={activeOrder} />
        </div>
      </div>
      <FloatingMenu logoutButton={true} homeButton={true} isBusiness={true} />
    </div>
  );
};

export default BusinessOrderDetailsPage;
